/**
 * コンクール応募フォーム：必須項目のバリデーション
 */
function initCompeContactForm() {
  const root = document.querySelector('.p-compe-contact__form');
  if (!root || root.querySelector('.wpcf7-form')) return;

  const form = root.matches('form') ? root : root.querySelector('form');
  if (!form) return;

  const responseOutput = form.querySelector('.p-compe-contact__response-output');
  if (!responseOutput) return;

  const MESSAGE_REQUIRED = '入力してください';
  const MESSAGE_FORMAT = '形式が違います';
  const MESSAGE_FORM_INVALID = '入力内容に問題があります。確認して再度お試しください。';

  const formatValidators = {
    'compe-email': (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()),
  };

  form.setAttribute('novalidate', '');

  const fields = form.querySelectorAll('[required]');
  const touchedFields = new WeakSet();
  const fieldErrors = new Map();

  const getFieldWrapper = (field) => {
    if (field.type === 'file') {
      return field.closest('.p-compe-contact__file');
    }

    return field;
  };

  const getFieldErrorClass = (field) => {
    if (field.classList.contains('p-compe-contact__textarea')) {
      return 'p-compe-contact__textarea--error';
    }

    if (field.type === 'file') {
      return 'p-compe-contact__file--error';
    }

    return 'p-compe-contact__input--error';
  };

  const getFieldValue = (field) => {
    if (field.type === 'file') {
      return field.files && field.files.length > 0 ? field.files[0].name : '';
    }

    return field.value.trim();
  };

  const getErrorInsertTarget = (field) => {
    if (field.type === 'file') {
      return field.closest('.p-compe-contact__file');
    }

    return field;
  };

  const hideFieldError = (field, errorEl) => {
    const target = getFieldWrapper(field);

    errorEl.hidden = true;
    errorEl.textContent = '';
    target.classList.remove(getFieldErrorClass(field));
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
  };

  const showFieldError = (field, errorEl, message) => {
    const target = getFieldWrapper(field);

    errorEl.textContent = message;
    errorEl.hidden = false;
    target.classList.add(getFieldErrorClass(field));
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', errorEl.id);
  };

  const validateField = (field, errorEl, showMessage) => {
    const value = getFieldValue(field);
    const formatValidator = formatValidators[field.id];

    if (value === '') {
      if (showMessage) {
        showFieldError(field, errorEl, MESSAGE_REQUIRED);
      }

      return false;
    }

    if (formatValidator && !formatValidator(field.value)) {
      if (showMessage) {
        showFieldError(field, errorEl, MESSAGE_FORMAT);
      }

      return false;
    }

    if (showMessage) {
      hideFieldError(field, errorEl);
    }

    return true;
  };

  const isFormValid = () => {
    return Array.from(fields).every((field) => {
      return validateField(field, fieldErrors.get(field), false);
    });
  };

  const showFormError = () => {
    form.classList.add('invalid');
    responseOutput.textContent = MESSAGE_FORM_INVALID;
    responseOutput.setAttribute('aria-hidden', 'false');
  };

  const clearFormError = () => {
    if (!isFormValid()) return;

    form.classList.remove('invalid');
    responseOutput.textContent = '';
    responseOutput.setAttribute('aria-hidden', 'true');
  };

  fields.forEach((field) => {
    const errorEl = document.createElement('p');
    errorEl.className = 'p-compe-contact__error';
    errorEl.id = `${field.id}-error`;
    errorEl.setAttribute('role', 'alert');
    errorEl.hidden = true;
    getErrorInsertTarget(field).insertAdjacentElement('afterend', errorEl);
    fieldErrors.set(field, errorEl);

    const handleFieldUpdate = () => {
      if (touchedFields.has(field)) {
        validateField(field, errorEl, true);
      }

      clearFormError();
    };

    if (field.type === 'file') {
      field.addEventListener('change', () => {
        touchedFields.add(field);
        handleFieldUpdate();
      });
    } else {
      field.addEventListener('blur', () => {
        touchedFields.add(field);
        validateField(field, errorEl, true);
        clearFormError();
      });

      field.addEventListener('input', handleFieldUpdate);
    }
  });

  form.addEventListener('submit', (event) => {
    if (isFormValid()) return;

    event.preventDefault();

    fields.forEach((field) => {
      touchedFields.add(field);
      validateField(field, fieldErrors.get(field), true);
    });

    showFormError();
  });
}

/**
 * コンクール応募フォーム：ファイル選択時の表示名更新
 */
function initCompeContactFileNames() {
  const forms = document.querySelectorAll('.p-compe-contact__form');

  forms.forEach((form) => {
    const fileInputs = form.querySelectorAll('.p-compe-contact__file-input');

    fileInputs.forEach((input) => {
      if (input.dataset.compeFileNameInit === 'true') return;

      input.dataset.compeFileNameInit = 'true';

      const fileNameEl = input.closest('.p-compe-contact__file')?.querySelector('.p-compe-contact__file-name');
      if (!fileNameEl) return;

      input.addEventListener('change', () => {
        const fileName = input.files && input.files.length > 0 ? input.files[0].name : '選択されていません';
        fileNameEl.textContent = fileName;
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initCompeContactForm);
document.addEventListener('DOMContentLoaded', initCompeContactFileNames);
document.addEventListener('wpcf7domready', initCompeContactFileNames);
